"use client";
// Small client helpers for /public/listings, whose filters are a plain GET form rendered on the server.
import { useState, type ReactNode } from "react";
import { SlidersHorizontal } from "lucide-react";

// On phones the filters fold away behind a button; on wide screens they always show.
export function FiltersToggle({ active, children }: { active: number; children: ReactNode }) {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <button type="button" aria-expanded={open} aria-controls="listing-filters" onClick={() => setOpen((value) => !value)}
        className="inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-xl border border-slate-300 bg-white px-4 font-semibold text-slate-800 lg:hidden">
        <SlidersHorizontal size={18} aria-hidden /> {open ? "Hide filters" : "Filters"}{active ? ` (${active})` : ""}
      </button>
      <div id="listing-filters" className={`${open ? "mt-3 block" : "hidden"} lg:mt-0 lg:block`}>{children}</div>
    </div>
  );
}

// Changing the sort reloads the list at once.
export function SortSelect({ value, options }: { value: string; options: ReadonlyArray<{ key: string; label: string }> }) {
  return (
    <select name="sort" form="listing-filter-form" defaultValue={value} aria-label="Sort by" onChange={(event) => event.currentTarget.form?.requestSubmit()}
      className="h-11 rounded-xl border border-slate-300 bg-white px-3 text-sm font-semibold text-slate-800">
      {options.map((option) => <option key={option.key} value={option.key}>{option.label}</option>)}
    </select>
  );
}
